// Sons próprios dos avisos (texto 10, A1; texto 11g, item 3). Os arquivos ficam em assets/sounds/ e entram
// no app instalado pelo plugin do expo-notifications (app.json > "sounds"): só chegam com o PRÓXIMO app novo.
//
// Como o app sabe se o app instalado já tem os sons: o tocador de áudio (expo-audio) entra no MESMO app novo.
// Se o módulo nativo dele existe, os sons também existem. No app antigo (só a atualização automática) o módulo
// não existe: a opção "Alarme (som)" e a lista de sons ficam escondidas e os avisos usam o som padrão do sistema.
// O expo-audio NUNCA é importado no topo: no app antigo isso derrubaria o app.
import { Platform } from 'react-native';
import { N_ } from './i18n';

let audioNativo: unknown = null;
if (Platform.OS !== 'web') {
  try { audioNativo = require('expo-modules-core').requireOptionalNativeModule('ExpoAudio'); } catch { audioNativo = null; }
}

/** O app instalado tem os sons próprios dos avisos (e o tocador para ouvir)? Não muda enquanto o app está aberto. */
export const temSonsProprios = () => !!audioNativo;

/** id (nome do arquivo, sem extensão: o Android só aceita letras minúsculas, números e _), nome na tela e o arquivo. */
export const SONS: { id: string; nome: string; arquivo: number }[] = [
  { id: 'mp_sino', nome: N_('Sino'), arquivo: require('../assets/sounds/mp_sino.wav') },
  { id: 'mp_marimba', nome: N_('Marimba'), arquivo: require('../assets/sounds/mp_marimba.wav') },
  { id: 'mp_cristal', nome: N_('Cristal'), arquivo: require('../assets/sounds/mp_cristal.wav') },
  { id: 'mp_gota', nome: N_('Gota'), arquivo: require('../assets/sounds/mp_gota.wav') },
  { id: 'mp_aurora', nome: N_('Aurora'), arquivo: require('../assets/sounds/mp_aurora.wav') },
  { id: 'mp_campainha', nome: N_('Campainha'), arquivo: require('../assets/sounds/mp_campainha.wav') },
  { id: 'mp_brisa', nome: N_('Brisa'), arquivo: require('../assets/sounds/mp_brisa.wav') },
  { id: 'mp_pulso', nome: N_('Pulso'), arquivo: require('../assets/sounds/mp_pulso.wav') },
  { id: 'mp_alvorada', nome: N_('Alvorada'), arquivo: require('../assets/sounds/mp_alvorada.wav') },
  { id: 'mp_harpa', nome: N_('Harpa'), arquivo: require('../assets/sounds/mp_harpa.wav') },
];
export const SOM_PADRAO = 'mp_sino';

/** O som escolhido existe neste app? Devolve o id válido, ou null (= som padrão do sistema). */
export function somValido(id: string | null | undefined): string | null {
  if (!temSonsProprios()) return null;
  const s = SONS.find(x => x.id === (id || SOM_PADRAO));
  return s ? s.id : SOM_PADRAO;
}
/** Nome do arquivo para o aviso (content.sound e som do canal do Android). */
export const arquivoDoSom = (id: string) => `${id}.wav`;

// ─── ▶ Ouvir (só no app com os sons) ───
type Tocador = { play(): void; pause(): void; remove(): void; seekTo(s: number): Promise<void> };
let tocando: Tocador | null = null;
/** Toca o som uma vez. Devolve false quando não dá (app sem o tocador). */
export function ouvirSom(id: string): boolean {
  if (!temSonsProprios()) return false;
  const s = SONS.find(x => x.id === id);
  if (!s) return false;
  try {
    const A = require('expo-audio') as typeof import('expo-audio');
    try { tocando?.remove(); } catch { /* já liberado */ }
    const p = A.createAudioPlayer(s.arquivo) as unknown as Tocador;
    tocando = p;
    p.play();
    // libera o tocador depois do som (os sons têm até 2 s)
    setTimeout(() => { if (tocando === p) { try { p.remove(); } catch { /* ok */ } tocando = null; } }, 4000);
    return true;
  } catch { return false; }
}
